import { MainPageHeader, SectionCard, SectionCard2 } from "main/components";
import React, { useEffect, useState } from "react";
import Whyyantrbanner from "main/assets/images/Images/Why Yantr-ai-Images/imagebanner.png";
import whyyantrmobilebanner from "main/assets/images/Images/Why Yantr-ai-Images/why_yantr_banner.png";
import whystrategic from "main/assets/images/Images/Why Yantr-ai-Images/why_strategic.png";
import whyoperational from "main/assets/images/Images/Why Yantr-ai-Images/why_operational.png";
import whytactical from "main/assets/images/Images/Why Yantr-ai-Images/why_tactical.png";
import Rectangle from "main/assets/images/Images/Why Yantr-ai-Images/Rectangle.png";
import Rectangle1 from "main/assets/images/Images/Why Yantr-ai-Images/Rectangle1.png";
import Rectangle2 from "main/assets/images/Images/Why Yantr-ai-Images/Rectangle2.png";
import content from "main/helpers/contentHelper.json";
import image1 from "main/assets/images/Images/Why Yantr-ai-Images/image1.png";
import image2 from "main/assets/images/Images/Why Yantr-ai-Images/image2.png";
import image3 from "main/assets/images/Images/Why Yantr-ai-Images/image3.png";
import image4 from "main/assets/images/Images/Why Yantr-ai-Images/image4.png";
import image5 from "main/assets/images/Images/Why Yantr-ai-Images/image5.png";
import image6 from "main/assets/images/Images/Why Yantr-ai-Images/image6.png";
import image7 from "main/assets/images/Images/Why Yantr-ai-Images/image7.png";
import image8 from "main/assets/images/Images/Why Yantr-ai-Images/image8.png";
import ordermanagement from "main/assets/images/Images/Why Yantr-ai-Images/order-managemnet-black.svg";
import vendormanagement from "main/assets/images/Images/Why Yantr-ai-Images/vendor-management-black.svg";
import scenariomoduling from "main/assets/images/Images/Why Yantr-ai-Images/scenario-moduling-black.svg";
import strategicplanning from "main/assets/images/Images/Why Yantr-ai-Images/strategic-planning-black.svg";
import capacityplanning from "main/assets/images/Images/Why Yantr-ai-Images/capacity-planning-black.svg";
import routplanning from "main/assets/images/Images/Why Yantr-ai-Images/rout-planning-black.svg";
import inventoryplanning from "main/assets/images/Images/Why Yantr-ai-Images/inventory-planning-black.svg";
import customerexperience from "main/assets/images/Images/Why Yantr-ai-Images/customer-experience-black.svg";
import bottumarrow from "main/assets/images/Images/Why Yantr-ai-Images/bottumarrow.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import SectionCardsMobile from "main/components/componentsHelper/whtyantrapage/SectionCardsMobile";
import SectionCardWhy from "main/components/componentsHelper/whtyantrapage/sectionCardWhy";
import { Col } from "react-bootstrap";

const Challenges = [
  {
    category: "STRATEGIC",
    image: Rectangle,
    mobileImage: whystrategic,
    title: "Command Center",
    subTitle:
      "The strategic command centre serves as the operational heart of an organization, providing centralized oversight and decision-making capabilities. It integrates data from various sources to enable real-time strategic planning, resource allocation, and crisis management, ensuring a cohesive and prompt response to emerging challenges and opportunities..",
  },
  {
    category: "OPERATIONAL",
    image: Rectangle1,
    mobileImage: whyoperational,
    title: "Distribution",
    subTitle:
      "Ensure that the right resources are allocated to the right tasks, for effective SLA adherence. This system dynamically adjusts to demand fluctuations and personnel availability, enhancing operational efficiency and customer satisfaction.",
  },
  {
    category: "TACTICAL",
    image: Rectangle2,
    mobileImage: whytactical,
    title: "Jeopardy",
    subTitle:
      "Real-time data and predictive analytics to swiftly identify and address potential service disruptions before they impact operations. This proactive approach allows for optimized decision-making, ensuring that resources are effectively aligned to meet urgent needs and maintain service continuity.",
  },
];

const ImageChain = [
  {
    position: "left",
    image: image1,
    blackImage: ordermanagement,
  },
  {
    position: "left",
    image: image2,
    blackImage: vendormanagement,
  },
  {
    position: "left",
    image: image3,
    blackImage: scenariomoduling,
  },
  {
    position: "bottom",
    image: image4,
    blackImage: strategicplanning,
  },
  {
    position: "right",
    image: image5,
    blackImage: capacityplanning,
  },
  {
    position: "right",
    image: image6,
    blackImage: routplanning,
  },
  {
    position: "right",
    image: image7,
    blackImage: inventoryplanning,
  },
  {
    position: "",
    image: image8,
    blackImage: customerexperience,
  },
];
type Props = {};

const WhyYatri = (props: Props) => {
  const [data, setData] = useState<any>(undefined);
  const [category, setCategory] = useState("STRATEGIC");

  useEffect(() => {
    window.scrollTo(0, 0);
    setData(content);
  }, []);

  const handleCategoryClick = (category: any) => {
    setCategory(category);
  };

  const filterChallenges = Challenges.filter((item) => {
    if (category === "STRATEGIC") return item.category === "STRATEGIC";
    if (category === "OPERATIONAL") return item.category === "OPERATIONAL";
    if (category === "TACTICAL") return item.category === "TACTICAL";
  });

  const [ImageChains, setimageChains] = useState(ImageChain);

  const MouseEnter = (index) => {
    setimageChains(
      ImageChains.map((telecom: any, telindex: number) => {
        if (telindex === index) {
          return { ...telecom, selected: 1 };
        } else {
          return { ...telecom, selected: 0 };
        }
      })
    );
  };
  const MouseLeave = () => {
    setimageChains(
      ImageChains.map((telecom: any, telindex: number) => {
        return { ...telecom, selected: 0 };
      })
    );
  };

  return (
    <>
      <div className="whyyantrai">
        <MainPageHeader
          mobilebgImage={whyyantrmobilebanner}
          backgroundImage={Whyyantrbanner}
          whyYantrHead={data ? data?.whyyantrai?.headerTitle : ""}
          subwhyYantrHead={data ? data?.whyyantrai?.headerDesc : ""}
          descriptionClass="text-white-color font-family-roboto"
        />
        {/* Mobile View */}
        <div className="d-block d-md-none">
          <div className="setion2 container-fluid text-center py-40 px-0">
            <p className="text-primary1 font-30 font-family-roboto line-35 fonts-800 pb-20 whyyantr-head">
              {data ? data?.whyyantrai?.subHeading : ""}
            </p>
            <div className="cardsection px-30 ">
              <div className="col-md-12 col-sm-12 col-lg-12">
                {data &&
                  data?.whyyantrai?.card?.map((item: any, index: any) => {
                    return (
                      <>
                        <div className="d-flex flex-wrap justify-content-center  col-md-12 col-sm-12 col-lg-12 gap-10 px-30 pb-15">
                          <SectionCardsMobile
                            title={item.title}
                            icon={item.image}
                            whiteIcon={item.whiteIcon}
                            desc={item.desc}
                            percent={item.percent}
                            percentDesc={item.percentDesc}
                          />
                        </div>
                      </>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
        {/* Website View */}
        <div className="container d-none d-md-block">
          <section className="container py-60 d-flex font-family-roboto flex-column align-items-center">
            <p className="dark-header fonts-800 font-30 mb-50 line-35 font-family-roboto text-align-center para-heading">
              {data ? data?.whyyantrai?.subHeading : ""}
            </p>{" "}
            <div className="row justify-content-center cardsection px-mob-140 px-70">
              {data &&
                data?.whyyantrai?.card?.map((item: any, index: any) => {
                  return (
                    <div className="col-md-6 col-sm-12 col-lg-4 p-10">
                      <div className="" key={index}>
                        <div
                          className={`tcard-container d-flex flex-column py-20 radius-10 justify-content-center border border-1`}
                        >
                          <div className="image-container">
                            <img
                              className="tfront-image mx-5 my-3 mt-5"
                              src={item?.image}
                              alt="background will be here"
                            />
                            <img
                              className="tback-image mx-5 my-3"
                              src={item?.whiteIcon}
                              alt="background will be here"
                            />
                          </div>
                          <div className="card-body">
                            <p
                              className={`d-flex justify-content-center text-center card-title px-5 fonts-600 font-family-roboto font-24 line-26 pb-2`}
                              style={{ color: "#3D1187" }}
                            >
                              {item?.title}
                            </p>
                            <p
                              className="px-3 tcard-desc text-center text-white-color fonts-400 font-18 line-20 font-family-roboto"
                              style={{ color: "#3D1187" }}
                            >
                              {item?.desc}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </section>
        </div>
        <div className="section3 font-family-roboto pb-60 text-center d-none d-md-block">
          <img
            className="mb-20"
            src="/assets/icons/Why Yantr-ai-Icons/downarrow.svg"
            alt=""
          />
          <p className="d-none d-md-block fonts-600 font-30 text-black-95 line-35.16 mb-30">
            {data?.whyyantrai?.subHeading2}
          </p>
          <div
            className="cardsection d-flex flex-row  why-yantr-gap justify-content-center"
            id="flex-row-mob"
          >
            {data &&
              data?.whyyantrai?.countCards?.map((item: any, index: any) => {
                return (
                  <>
                    <SectionCard2
                      title={item.title}
                      icon={item.image}
                      desc={item.desc}
                    />
                  </>
                );
              })}
          </div>
        </div>
        {/* Mobile View */}
        <div className="d-block d-md-none">
          <div className="bg-color-n navbars">
            <div className="section4 bg-color-n container flex-column">
              <div className="text-center pt-20">
                <p className="text-white-color font-30 fonts-800 font-family-roboto line-35 pb-20 px-22 whyyantr-title">
                  {data ? data?.whyyantrai?.demoSection?.title : ""}
                </p>
              </div>
              <div className="row mx-1 mb-40 p-10">
                <Swiper
                  slidesPerView={"auto"}
                  spaceBetween={0}
                  pagination={{
                    clickable: true,
                  }}
                  modules={[Pagination]}
                  className="my-yantra-ai-swiper customSwiper"
                >
                  {ImageChains.map((item: any, index: any) => (
                    <SwiperSlide>
                      <div className="col-md-12 col-sm-12 col-lg-12 p-0">
                        <div
                          key={index}
                          className="col-md-3 p-0 d-flex flex-gap-20 position-relative mobile-cards-width justify-content-center"
                          onMouseEnter={() => MouseEnter(index)}
                          onMouseLeave={() => MouseLeave()}
                        >
                          <div className="">
                            <img
                              className="w-100"
                              src={
                                item?.selected ? item?.blackImage : item?.image
                              }
                              alt="background will be here"
                            />
                            {item.position !== "" ? (
                              <img
                                style={{}}
                                className={`position-absolute right-n-18 z-index-100 d-none d-lg-block ${
                                  index > 3 && "top-45"
                                } ${
                                  index < 3 &&
                                  "rotate-180 top-45 d-none d-lg-block"
                                } ${
                                  index === 3 &&
                                  "rotate-270 leftp-50 bottom-n-18 d-none d-lg-block"
                                }`}
                                src={bottumarrow}
                                alt="background will be here"
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
          <div className="navbars">
            <div className="section4 container flex-column">
              <div
                className={`container navbars d-flex fonts-400 mb-20 font-20 flex-gap-30 justify-content-center display-center`}
              >
                <p
                  role="button"
                  className={`text-black-95 font-family-roboto fonts-700 line-15 font-13 navlinks category-item ${
                    category === "STRATEGIC" ? "current" : ""
                  }`}
                  onClick={() => handleCategoryClick("STRATEGIC")}
                >
                  STRATEGIC
                </p>
                <p
                  role="button"
                  className={`text-black-95 font-family-roboto fonts-700 line-15 font-13 navlinks category-item ${
                    category === "OPERATIONAL" ? "current" : ""
                  }`}
                  onClick={() => handleCategoryClick("OPERATIONAL")}
                >
                  OPERATIONAL
                </p>
                <p
                  role="button"
                  className={`text-black-95 font-family-roboto fonts-700 line-15 font-13 navlinks category-item ${
                    category === "TACTICAL" ? "current" : ""
                  }`}
                  onClick={() => handleCategoryClick("TACTICAL")}
                >
                  TACTICAL
                </p>
              </div>
              <div className="d-flex px-10">
                {filterChallenges.map((item: any, index: any) => {
                  return (
                    <>
                      <div
                        key={index}
                        className={`d-flex row flex-gap-20 mb-40`}
                      >
                        <div className="col-md-4 col-sm-12">
                          <img
                            className="col-md-12 col-sm-12 col-12"
                            src={item?.mobileImage}
                            alt="background will be here"
                          />
                        </div>
                        <div className="col-md-7 col-sm-12 col-12">
                          <div className="d-flex justify-content-start flex-column align-items-start wp-100">
                            <p className="text-black-95 fonts-800 font-family-roboto font-16 mb-10 line-18">
                              {item?.title}
                            </p>
                            <p className="font-family-roboto fonts-400 font-13 line-16">
                              {item?.subTitle}
                            </p>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="background-bule-mobile navbars p-10">
            <div className="section4 background-bule-mobile container flex-column">
              <p className="text-white-color line-28 fonts-400 font-18 mb-20 font-family-roboto display-justify fontsize11">
                <span className="span-color"> * </span>
                Yantr.ai has revolutionized supply chain operations and field
                services management for customers across domains & locations,
                improving operational efficiency, reducing overall spend &
                enhancing customer experience. Yantrai helps minimize
                unproductive practices and allows admins to focus on more
                meaningful tasks - ultimately increasing your organization's
                bottom line while getting maximum value.
              </p>
            </div>
          </div>
        </div>
        <div className="d-none d-md-block">
          {/* website */}
          <div className="bg-color-n navbars">
            <div className="section4 bg-color-n container py-60 flex-column">
              <div className="text-center">
                <p className="text-white-color font-30 fonts-800 font-family-roboto line-35 pb-60 whyyantr-title">
                  {data ? data?.whyyantrai?.demoSection?.title : ""}
                </p>
              </div>
              <div className="container row px-40 px-mob-140 pb-60">
                {ImageChains.map((item: any, index: any) => {
                  return (
                    <>
                      <div
                        key={index}
                        className="col-md-3 p-0 d-flex flex-gap-20 position-relative mobile-cards-width justify-content-center"
                        onMouseEnter={() => MouseEnter(index)}
                        onMouseLeave={() => MouseLeave()}
                      >
                        <div className="">
                          <img
                            className="w-100"
                            src={
                              item?.selected ? item?.blackImage : item?.image
                            }
                            alt="background will be here"
                          />
                          {item.position !== "" ? (
                            <img
                              style={{}}
                              className={`position-absolute right-n-18 z-index-100 d-none d-lg-block ${
                                index > 3 && "top-45"
                              } ${
                                index < 3 &&
                                "rotate-180 top-45 d-none d-lg-block"
                              } ${
                                index === 3 &&
                                "rotate-270 leftp-50 bottom-n-18 d-none d-lg-block"
                              }`}
                              src={bottumarrow}
                              alt="background will be here"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>

              <div
                className={`container navbars d-flex text-white-color fonts-400 mb-40 font-20 flex-gap-30 justify-content-center display-center`}
              >
                <p
                  role="button"
                  className={`text-white-color font-family-roboto fonts-700 line-23 font-20 navlinks category-item ${
                    category === "STRATEGIC" ? "current" : ""
                  }`}
                  onClick={() => handleCategoryClick("STRATEGIC")}
                >
                  STRATEGIC
                </p>
                <p
                  role="button"
                  className={`text-white-color font-family-roboto fonts-700 line-23 font-20 navlinks category-item ${
                    category === "OPERATIONAL" ? "current" : ""
                  }`}
                  onClick={() => handleCategoryClick("OPERATIONAL")}
                >
                  OPERATIONAL
                </p>
                <p
                  role="button"
                  className={`text-white-color font-family-roboto fonts-700 line-23 font-20 navlinks category-item ${
                    category === "TACTICAL" ? "current" : ""
                  }`}
                  onClick={() => handleCategoryClick("TACTICAL")}
                >
                  TACTICAL
                </p>
              </div>
              <div className="container d-flex row padding-card">
                {filterChallenges.map((item: any, index: any) => {
                  return (
                    <>
                      <div
                        key={index}
                        className={`d-flex row flex-gap-20 mb-40`}
                      >
                        <div className="col-md-4 col-sm-12">
                          <img
                            className="col-md-12 col-sm-12 col-12"
                            src={item?.image}
                            alt="background will be here"
                          />
                        </div>
                        <div className="col-md-7 col-sm-12 col-12">
                          <div className="d-flex justify-content-start flex-column align-items-start wp-100">
                            <p className="text-white-color fonts-800 font-family-roboto font-26 mb-10 line-30">
                              {item?.title}
                            </p>
                            <p className="text-white-color font-family-roboto fonts-400 font-20 line-30">
                              {item?.subTitle}
                            </p>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
              <p className="line-28 fonts-400 font-18 text-white-color font-family-roboto display-center fontsize11">
                Yantr.ai has revolutionized supply chain operations and field
                services management for customers across domains & locations,
                improving operational efficiency, reducing overall spend &
                enhancing customer experience. Yantrai helps minimize
                unproductive practices and allows admins to focus on more
                meaningful tasks - ultimately increasing your organization's
                bottom line while getting maximum value.
              </p>
            </div>
          </div>
        </div>
        <div className="section5  position-relative radius-20 container hp-100 py-60">
          <p className="fonts-600 font-30 text-black-95 font-family-roboto text-center pb-60">
            {data ? data?.whyyantrai?.deliver?.title : "Demo Title"}
          </p>
          <div
            className="d-flex justify-content-evenly flex-row flex-wrap gap-4 position-relative "
            id="flex-row-mob"
            style={{ zIndex: 2 }}
          >
            {data &&
              data?.whyyantrai?.deliver?.cards?.map((item: any, index: any) => {
                return (
                  <>
                    <div
                      key={index}
                      className="d-flex justify-content-center align-items-center flex-column"
                    >
                      <p className="text-violet-50 font-60 fonts-600 line-70.31 font-family-roboto m-font30">
                        {item?.title}
                      </p>
                      <p className="w-80 text-black-90 font-20 fonts-400 line-26 text-center m-auto font-family-roboto plat-desc">
                        {item?.desc}
                      </p>
                    </div>
                  </>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
};

export default WhyYatri;
